module.exports = __webpack_public_path__ + "924a788c8149f2cbd5e03c53e5e55d5a.jpg";